import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DriverManagementError } from '@cordic/driver-management';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppRoutes } from 'src/app/app-routes';
import { ValidCodeModalComponent } from 'src/app/components/valid-code-modal/valid-code-modal.component';
import { SubmittableForm } from 'src/app/models/base/submittable-form.base';
import { RegisterService } from 'src/app/services/register-service/register.service';

@Component({
  selector: 'app-enter-phone',
  templateUrl: './enter-phone.component.html',
  styleUrls: ['./enter-phone.component.scss']
})
export class EnterPhoneComponent extends SubmittableForm {

  faBack = faArrowLeft;
  AppRoutes = AppRoutes;

  constructor(
    translateService: TranslateService, 
    private registerService: RegisterService, 
    private router: Router, 
    public modalService: NgbModal, 
    private spinner: NgxSpinnerService) 
  {
    super(translateService)
  }

  override form = new FormGroup({
    phone: new FormControl('', {
      validators: [Validators.required, Validators.minLength(6)]
    })
  });

  async onLoginSubmitted()
  {
    this.spinner.show();

    return super.onConfirm(
      () => this.registerService.requestVerifyCode(this.form.value.phone as string),
      {
        onSuccess: () => { 
          this.spinner.hide();

          this.router.navigate([AppRoutes.VerifyCode, this.form.value.phone]);
        },
        onError: async () => {
          this.spinner.hide();

          await this.router.navigate([AppRoutes.VerifyCode, this.form.value.phone]);

          const modalRef = this.modalService.open(ValidCodeModalComponent, {backdrop: 'static', centered: true });

          modalRef.componentInstance.modalText = this.translateService.instant('IDS_VALID_CODE_MODAL_BODY', { phoneNo: this.form.value.phone});
        },
        onErrorPredicate: ((error) => {
          return error.subscribe((error: any) =>  error && error.code === DriverManagementError.VERIFY_CODE_STILL_VALID);
        })
      });
  }

  shouldAllowRequest(): boolean
  {
    return this.form.controls.phone.invalid;
  }

}
